module.exports = __webpack_public_path__ + "img/adobe.1a5140a6.jpg";